type TokenUpdateHandler = (token: string | null) => void;
type ClearSessionHandler = () => void;

let tokenUpdateHandler: TokenUpdateHandler | null = null;
let clearSessionHandler: ClearSessionHandler | null = null;

export function registerAuthEvents(handlers: { onTokenUpdate: TokenUpdateHandler; onClearSession: ClearSessionHandler }) {
  tokenUpdateHandler = handlers.onTokenUpdate;
  clearSessionHandler = handlers.onClearSession;
}

export function emitTokenUpdate(token: string | null) {
  tokenUpdateHandler?.(token);
}

export function emitClearSession() {
  clearSessionHandler?.();
}
